<template>
  <v-app>
      <Layout/>
   </v-app>
</template>
<script>
import Layout from './components/Layout'

export default {
  name: 'App',
  components: {
    Layout
  },
  data () {
    return {
  
    }
  },
  methods: {
    
  } 
}
</script>
